import React from "react";
import "../projects.css";

export default function Projects() {
  return (
  <div className="projects">
    <div className="cards" id="flexbox-container" >
 
      <div className="card" id="flexbox-item"  >
        <div className="imgBx">
          <img
            id="avitar"
            src={require("../images/weahterappmetric.png")}
            alt="pic"
          />
        </div>
        <div className="contentP">
          <div className="details">
            <h2>
              Jay Tranberg<br></br>
              <span> Developer</span>
            </h2>
            <div className="data">
              <h3>
                Weather <br></br>
                <span>Open Source</span>
              </h3>
              <h3>
                Current<br></br>
                <span>Hourly,Daily</span>
              </h3>
              <h3>
                Metric<br></br>
                <span>App</span>
              </h3>
            </div>
            <div className="actionBtn">
              <div className="containerGlass">
                <div className="btn">
                  <a
                    href="https://localweatherappmetric.netlify.app/"
                    target="blank"
                  >
                    Local Weather
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* new card */}
      <div className="card" id="flexbox-item">
        <div className="imgBx">
          <img
            id="avitar"
            src={require("../images/3d scroll.png")}
            alt="pic"
          />
        </div>
        <div className="contentP">
          <div className="details">
            <h2>
              Jay Tranberg<br></br>
              <span> Developer</span>
            </h2>
            <div className="data">
              <h3>
                3D Scroll <br></br>
                <span>Open Source</span>
              </h3>
              <h3>
                Vanilla<br></br>
                <span>3d</span>
              </h3>
              <h3>
                Scroll<br></br>
                <span>App</span>
              </h3>
            </div>
            <div className="actionBtn">
              <div className="containerGlass">
                <div className="btn">
                  <a
                    href="https://3dscrollevent.netlify.app/"
                    target="blank"
                  >
                    3D scroll
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* new card */}
      <div className="card" id="flexbox-item">
        <div className="imgBx">
          <img
            id="avitar"
            src={require("../images/animated box.png")}
            alt="pic"
          />
        </div>
        <div className="contentP">
          <div className="details">
            <h2>
              Jay Tranberg<br></br>
              <span>Senior UX / Developer</span>
            </h2>
            <div className="data">
              <h3>
               CSS <br></br>
                <span>animate</span>
              </h3>
              <h3>
                Animation<br></br>
                <span>3d</span>
              </h3>
              <h3>
                Front End<br></br>
                <span>element</span>
              </h3>
            </div>
            <div className="actionBtn">
              <div className="containerGlass">
                <div className="btn">
                  <a
                    href="https://3d-animated-cube.netlify.app/"
                    target="blank"
                  >
                    3D Box
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="card" id="flexbox-item"  >
        <div className="imgBx">
          <img
            id="avitar"
            src={require("../images/3DCube.png")}
            alt="pic"
          />
        </div>
        <div className="contentP">
          <div className="details">
            <h2>
              Jay Tranberg<br></br>
              <span> Developer</span>
            </h2>
            <div className="data">
              <h3>
                3D Cube <br></br>
                <span>CSS</span>
              </h3>
              <h3>
                Animated<br></br>
                <span>Cube</span>
              </h3>
              <h3>
                Front End<br></br>
                <span>Element</span>
              </h3>
            </div>
            <div className="actionBtn">
              <div className="containerGlass">
                <div className="btn">
                  <a
                    href="https://numberedcube.netlify.app/"
                    target="blank"
                  >
                    3D Cube
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* new card */}
      <div className="card" id="flexbox-item">
        <div className="imgBx">
          <img
            id="avitar"
            src={require("../images/liquid.png")}
            alt="pic"
          />
        </div>
        <div className="contentP">
          <div className="details">
            <h2>
              Jay Tranberg<br></br>
              <span> Developer</span>
            </h2>
            <div className="data">
              <h3>
                Liquid Jar <br></br>
                <span>Open Source</span>
              </h3>
              <h3>
                CSS<br></br>
                <span>Animation</span>
              </h3>
              <h3>
                Front End<br></br>
                <span>Element</span>
              </h3>
            </div>
            <div className="actionBtn">
              <div className="containerGlass">
                <div className="btn">
                  <a
                    href="https://tiltingliquidinjar.netlify.app/"
                    target="blank"
                  >
                    Tilting Jar
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* new card */}
      <div className="card" id="flexbox-item">
        <div className="imgBx">
          <img
            id="avitar"
            src={require("../images/glass morphism buttons.png")}
            alt="pic"
          />
        </div>
        <div className="contentP">
          <div className="details">
            <h2>
              Jay Tranberg<br></br>
              <span>Senior UX / Developer</span>
            </h2>
            <div className="data">
              <h3>
                Buttons <br></br>
                <span>glass morphism</span>
              </h3>
              <h3>
                CSS<br></br>
                <span>wallet</span>
              </h3>
              <h3>
                Front End<br></br>
                <span>Element</span>
              </h3>
            </div>
            <div className="actionBtn">
              <div className="containerGlass">
                <div className="btn">
                  <a
                    href="https://glassmorphismbutton.netlify.app/"
                    target="blank"
                  >
                    Glass Morphism
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card" id="flexbox-item"  >
        <div className="imgBx">
          <img
            id="avitar"
            src={require("../images/glassLogin.png")}
            alt="pic"
          />
        </div>
        <div className="contentP">
          <div className="details">
            <h2>
              Jay Tranberg<br></br>
              <span> Developer</span>
            </h2>
            <div className="data">
              <h3>
                Login <br></br>
                <span>Open Source</span>
              </h3>
              <h3>
                CSS<br></br>
                <span>Log in </span>
              </h3>
              <h3>
                Form<br></br>
                <span>Glass Morphism</span>
              </h3>
            </div>
            <div className="actionBtn">
              <div className="containerGlass">
                <div className="btn">
                  <a
                    href="https://glassmorphismloginform.netlify.app/"
                    target="blank"
                  >
                    LogIn Glass
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* new card */}
      <div className="card" id="flexbox-item">
        <div className="imgBx">
          <img
            id="avitar"
            src={require("../images/DeeLake.png")}
            alt="pic"
          />
        </div>
        <div className="contentP">
          <div className="details">
            <h2>
              Jay Tranberg<br></br>
              <span> Developer</span>
            </h2>
            <div className="data">
              <h3>
                Large  App <br></br>
                <span>Glide</span>
              </h3>
              <h3>
                App<br></br>
                <span>Live</span>
              </h3>
              <h3>
                Collab<br></br>
                <span>App</span>
              </h3>
            </div>
            <div className="actionBtn">
              <div className="containerGlass">
                <div className="btn">
                  <a
                    href="https://l.facebook.com/l.php?u=https%3A%2F%2Fdee-lake-wilderness--iec3.glide.page%2F%3Ffbclid%3DIwAR2QC3II7vQ_h4GArikTER_pam_JG-zwsnvl-ucezEHXpHxE3HvyLS0wBy4&h=AT1H2SgTPr_48HO9ACVOYRYBGK3WZgOqKNkrT_YDNe-YKfcy0YS7JbTn27xtV9sJjyPRcU8io22hHYe6-FPMtvOmefSJk1hxc783M_OtHzulMsFqsdlKlLYb6Gy9aa-F2Hg"
                    target="blank"
                  >
                    Dee Lake
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* new card */}
      <div className="card" id="flexbox-item">
        <div className="imgBx">
          <img
            id="avitar"
            src={require("../images/responsiveCards.png")}
            alt="pic"
          />
        </div>
        <div className="contentP">
          <div className="details">
            <h2>
              Jay Tranberg<br></br>
              <span>Senior UX / Developer</span>
            </h2>
            <div className="data">
              <h3>
                Cards <br></br>
                <span>Responsive</span>
              </h3>
              <h3>
                CSS<br></br>
                <span>Active</span>
              </h3>
              <h3>
               Front End<br></br>
                <span>Element</span>
              </h3>
            </div>
            <div className="actionBtn">
              <div className="containerGlass">
                <div className="btn">
                  <a
                    href="https://responsive-sevice-section-card.netlify.app/"
                    target="blank"
                  >
                    Responsive Card
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     </div>
  </div>
  );
}
